import { articles } from '@/mocks/articles';
import ArticleLayout from '@/pages/article/components/ArticleLayout';

export default function ArticleGuida() {
  const article = articles.find((a) => a.slug === 'guida-completa-itaobuy-spreadsheet')!;
  return <ArticleLayout article={article} />;
}